<template>
  <p 
    :class="getClass"
  >
    <slot></slot>
  </p>
</template>
<script>
export default {
  name: "SettingsText",
  props: {
    type: {
      type: String,
      validator: (type) => ["base", "tight"].includes(type),
    }
  },
  computed: {
    getClass() {
      if (this.type === "tight") {
        return "tight";
      }
      return "";
    }
  }
}
</script>
<style scoped>
p {
  display: block;
  font-size: 17px;
  line-height: 1.6;
  max-width: 500px;
  padding: 0px 2px;
}
.tight {
  line-height: 1.2;
  max-width: 330px;
}
</style>